export default class TgapExclureController {
	static $inject = ['$scope', '$stateParams', 'TgapExclureCommunicationService', 'TgapExclureService', 'notification', '$uibModal', 'SitesService'];

	constructor($scope, $stateParams, TgapExclureCommunicationService, TgapExclureService, notification, $uibModal, SitesService) {
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.TgapExclureCommunicationService = TgapExclureCommunicationService;
		this.TgapExclureService = TgapExclureService;
		this.notification = notification;
		this.$uibModal = $uibModal;
		this.SitesService = SitesService;
	}

	async $onInit() {
		this.isAllExclure = false;
		this.unregister = this.$scope.$watch(
			() => this.isOpen,
			() => {
				if (this.isOpen && !this.tgapExclures) {
					this.loadTgapExclure();
				}
			},
			true
		);
		this.hasUserAccess = await this.SitesService.checkProfilRights(!!this?.idClient, 'siteclient');
	}

	$onDestroy() {
		this.unregister();
	}

	async loadTgapExclure() {
		if (this.idClient) {
			this.startLoading();
			try {
				this.tgapExclures = await this.TgapExclureService.getTgapExclure(this.idClient, this.idChantier);
				if (this.tgapExclures.find((x) => x.isExclure)) {
					this.isAllExclure = true;
				} else {
					this.isAllExclure = false;
				}
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
			}
			this.stopLoading();
		}
	}

	async updateTgapExclure(tgapExclure) {
		if (!tgapExclure.isBloque) {
			if (tgapExclure.idTgapExclure) {
				this.TgapExclureService.deleteTgapExclureById(tgapExclure.idTgapExclure);
			} else {
				tgapExclure.idClient = this.idClient;
				tgapExclure.idChantier = this.idChantier;
				this.TgapExclureService.createTgapExclure(tgapExclure);
			}
		}
	}

	async changeExclure(tgapExclure) {
		await this.updateTgapExclure(tgapExclure);
		this.loadTgapExclure();
	}

	async changeAllExclure() {
		this.startLoading();
		console.log(this.isAllExclure);
		const tgapExclureSelecteds = this.tgapExclures.filter((x) => x.isExclure != this.isAllExclure);
		tgapExclureSelecteds.forEach(async function (element) {
			await this.updateTgapExclure(element);
		}, this);
		this.stopLoading();
		this.loadTgapExclure();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
